var _path, _path2, _path3, _path4, _path5, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnSmtp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 13.6035V22.6035C31 23.2003 30.7629 23.7726 30.341 24.1945C29.919 24.6165 29.3467 24.8535 28.75 24.8535H15.25C14.6533 24.8535 14.081 24.6165 13.659 24.1945C13.2371 23.7726 13 23.2003 13 22.6035V13.6035",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 13.6035C31 13.0068 30.7629 12.4345 30.341 12.0125C29.919 11.5906 29.3467 11.3535 28.75 11.3535H15.25C14.6533 11.3535 14.081 11.5906 13.659 12.0125C13.2371 12.4345 13 13.0068 13 13.6035L20.8075 18.4785C21.1651 18.702 21.5783 18.8205 22 18.8205C22.4217 18.8205 22.8349 18.702 23.1925 18.4785L31 13.6035Z",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 29.875H20",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 29.875H29",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22 27.875L22 25.875",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 30.1465,
    r: 1.75,
    stroke: "#172664",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnSmtp);
export default __webpack_public_path__ + "static/media/btn_smtp.396e0b0f073302d1fe6dfdccf68a50f3.svg";
export { ForwardRef as ReactComponent };